var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]",
    },
    [
      _c("navBar", { attrs: { title: _vm.$t("yoyoCoins.title") } }),
      _c(
        "div",
        { staticClass: "bg-white mx-4 mt-4 rounded-xl p-4 pb-2 text-center" },
        [
          _c("h3", { staticClass: "text-lg font-medium text-gray-800 mb-2" }, [
            _vm._v(_vm._s(_vm.$t("yoyoCoins.currentBalance"))),
          ]),
          _c("div", { staticClass: "flex items-center justify-center mb-2" }, [
            _c("img", {
              staticClass: "w-8 h-8 mr-1",
              attrs: { src: _vm.yoyoSrc, alt: "" },
            }),
            _c("span", { staticClass: "text-4xl font-bold text-[#ff7a00]" }, [
              _vm._v(_vm._s(_vm.extra.point || 0)),
            ]),
          ]),
          _vm.userInfo.level.level != 3 &&
          _vm.userInfo.level.level != 4 &&
          _vm.userInfo.level.level != 5
            ? _c("div", { staticClass: "text-sm text-gray-500 mb-4" }, [
                _vm._v(
                  " (" +
                    _vm._s(_vm.extra.expirePoint || 0) +
                    _vm._s(_vm.$t("yoyoCoins.expireDate")) +
                    _vm._s(_vm.extra.expireTime) +
                    _vm._s(_vm.$t("yoyoCoins.expireText")) +
                    ") "
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "text-left text-sm" }, [
            _c(
              "div",
              { staticClass: "flex justify-between items-center py-1" },
              [
                _c("span", { staticClass: "text-gray-600" }, [
                  _vm._v(_vm._s(_vm.$t("yoyoCoins.accumulated")) + "："),
                ]),
                _c("span", { staticClass: "font-medium" }, [
                  _vm._v(_vm._s(_vm.extra.totalPoint || 0)),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "flex justify-between items-center py-1" },
              [
                _c("span", { staticClass: "text-gray-600" }, [
                  _vm._v(_vm._s(_vm.$t("yoyoCoins.used")) + "："),
                ]),
                _c("span", { staticClass: "font-medium" }, [
                  _vm._v(" " + _vm._s(_vm.extra.usePoint || 0) + " "),
                  _c("span", { staticClass: "text-sm text-gray-400" }, [
                    _vm._v(
                      "(" +
                        _vm._s(_vm.$t("yoyoCoins.discountRM")) +
                        "RM" +
                        _vm._s(_vm.extra.usePointPrice) +
                        " )"
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "mx-4 mt-4 bg-white rounded-xl overflow-hidden" },
        [
          _c(
            "van-tabs",
            {
              staticClass: "yoyo-tabs yoyo-container",
              attrs: { sticky: "", "offset-top": "3rem" },
              on: { change: _vm.onTabChange },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "van-tab",
                {
                  attrs: {
                    title: _vm.$t("yoyoCoins.received"),
                    name: "received",
                  },
                },
                [
                  _vm.receivedRecords.length > 0
                    ? _c(
                        "van-pull-refresh",
                        {
                          on: { refresh: _vm.onRefreshReceived },
                          model: {
                            value: _vm.receivedRefreshing,
                            callback: function ($$v) {
                              _vm.receivedRefreshing = $$v
                            },
                            expression: "receivedRefreshing",
                          },
                        },
                        [
                          _c(
                            "van-list",
                            {
                              attrs: {
                                finished: _vm.receivedFinished,
                                "finished-text": _vm.$t("query.noMoreData"),
                                "loading-text": _vm.$t("query.loading"),
                              },
                              on: { load: _vm.onLoadReceived },
                              model: {
                                value: _vm.receivedLoading,
                                callback: function ($$v) {
                                  _vm.receivedLoading = $$v
                                },
                                expression: "receivedLoading",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "px-4" },
                                _vm._l(
                                  _vm.receivedRecords,
                                  function (record, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "py-4 border-b border-gray-100 last:border-b-0",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex justify-between items-start",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex-1" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-medium text-gray-800 mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.isZh
                                                          ? record.title
                                                          : record.titleEn
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-sm text-gray-500 mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.isZh
                                                          ? record.description
                                                          : record.descriptionEn
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-sm text-gray-400",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatTime(
                                                          record.createTime
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "text-right" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-lg font-bold text-green-500",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "+" + _vm._s(record.point)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.receivedRecords.length === 0
                    ? _c("van-empty", {
                        attrs: { description: _vm.$t("common.noData") },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "van-tab",
                {
                  attrs: {
                    title: _vm.$t("yoyoCoins.usageRecord"),
                    name: "usage",
                  },
                },
                [
                  _vm.usageRecords.length > 0
                    ? _c(
                        "van-pull-refresh",
                        {
                          on: { refresh: _vm.onRefreshUsage },
                          model: {
                            value: _vm.usageRefreshing,
                            callback: function ($$v) {
                              _vm.usageRefreshing = $$v
                            },
                            expression: "usageRefreshing",
                          },
                        },
                        [
                          _c(
                            "van-list",
                            {
                              attrs: {
                                finished: _vm.usageFinished,
                                "finished-text": _vm.$t("query.noMoreData"),
                                "loading-text": _vm.$t("query.loading"),
                              },
                              on: { load: _vm.onLoadUsage },
                              model: {
                                value: _vm.usageLoading,
                                callback: function ($$v) {
                                  _vm.usageLoading = $$v
                                },
                                expression: "usageLoading",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "px-4" },
                                _vm._l(
                                  _vm.usageRecords,
                                  function (record, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "py-4 border-b border-gray-100 last:border-b-0",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex justify-between items-start",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex-1" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-medium text-gray-800 mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.isZh
                                                          ? record.title
                                                          : record.titleEn
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-sm text-gray-500 mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.isZh
                                                          ? record.description
                                                          : record.descriptionEn
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-sm text-gray-400",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatTime(
                                                          record.createTime
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "text-right" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-lg font-bold text-red-500",
                                                  },
                                                  [_vm._v(_vm._s(record.point))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.usageRecords.length === 0
                    ? _c("van-empty", {
                        attrs: { description: _vm.$t("common.noData") },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }